<form [formGroup]="usuarioForm" (ngSubmit)="onSubmit()" class="p-fluid">
    <div class="p-formgrid p-grid">
        <h1 class="text-center font-medium fon">Registro de Administrador</h1>
        <!-- Email -->
        <div class="p-field p-col-12 p-md-6">
            <label for="email">Email*</label>
            <input id="email" type="email" pInputText formControlName="email"
                [ngClass]="{'ng-invalid ng-dirty': f['email'].invalid && (f['email'].dirty || f['email'].touched)}" />
            <small *ngIf="f['email'].invalid && (f['email'].dirty || f['email'].touched)" class="p-error">
                <span *ngIf="f['email'].errors?.['required']">Correo obligatorio.</span>
                <span *ngIf="f['email'].errors?.['email']">Email inválido.</span>
            </small>
        </div>

        <!-- Contraseña -->
        <div class="p-field p-col-12 p-md-6">
            <label for="contrasena">Contraseña*</label>
            <p-password inputId="contrasena" formControlName="contrasena" [feedback]="true" [toggleMask]="true"
                promptLabel="Introduce una contraseña segura" weakLabel="Débil" mediumLabel="Media" strongLabel="Fuerte"
                inputStyleClass="password-input" [style]="{'width':'100%'}"></p-password>
            <small *ngIf="f['contrasena'].invalid && (f['contrasena'].dirty || f['contrasena'].touched)"
                class="p-error">
                <span *ngIf="f['contrasena'].errors?.['required']">Contraseña obligatoria.</span>
                <span *ngIf="f['contrasena'].errors?.['minlength']">Mínimo 6 caracteres.</span>
            </small>
        </div>

        <!-- Contraseña Confirmacion-->
        <div class="p-field p-col-12 p-md-6">
            <label for="contrasena_c">Contraseña de Confirmacion*</label>
            <p-password inputId="contrasena_c" formControlName="contrasena_confirmation" [feedback]="false"
                [toggleMask]="true" inputStyleClass="password-input" [style]="{'width':'100%'}"></p-password>
            <small
                *ngIf="f['contrasena_confirmation'].invalid && (f['contrasena_confirmation'].dirty || f['contrasena_confirmation'].touched)"
                class="p-error">
                <span *ngIf="f['contrasena_confirmation'].errors?.['required']">Contraseña obligatoria.</span>
                <span *ngIf="f['contrasena_confirmation'].errors?.['minlength']">Mínimo 6 caracteres.</span>
                <span *ngIf="f['contrasena_confirmation'].hasError('passwordMismatch')"> Las contraseñas no
                    coinciden.</span>
            </small>
        </div>

        <!-- Nombre -->
        <div class="p-field p-col-12 p-md-6">
            <label for="nombre">Nombre*</label>
            <input id="nombre" type="text" pInputText formControlName="nombre"
                [ngClass]="{'ng-invalid ng-dirty': f['nombre'].invalid && (f['nombre'].dirty || f['nombre'].touched)}" />
            <small *ngIf="f['nombre'].invalid && (f['nombre'].dirty || f['nombre'].touched)" class="p-error">
                <span *ngIf="f['nombre'].errors?.['required']">Se requiere nombre.</span>
            </small>
        </div>



        <!-- Botón -->
        <div class="p-field p-col-12">
            <button type="submit" pButton label="Registrar" [disabled]="usuarioForm.invalid"></button>
        </div>
    </div>
</form>
<p-toast></p-toast>